
<section class="location-area {{ptb}}">
    <div class="container">
        <div ng- class="section-title">
            <h2>Centros de 
                Datos</h2>
            <p class="text-justify">En enCloud, sabemos que la ubicación de tus datos es clave para un acceso rápido, seguro y eficiente. Por eso, contamos con una red de centros de datos estratégicamente distribuidos en diversas regiones.</p>
        </div>

        <div class="map-img">
            <img src="assets/img/map-img.png" alt="Image">

            <div *ngIf="showSites" class="single-location video-btn">
                <i class="bx bx-location-plus"></i>
                <span>Russia</span>
            </div>

            <div  *ngIf="showSites" class="single-location location-two video-btn">
                <i class="bx bx-location-plus"></i>
                <span>London</span>
            </div>

            <div *ngIf="showSites" class="single-location location-three video-btn">
                <i class="bx bx-location-plus"></i>
                <span>Canada</span>
            </div>

            <div *ngIf="showSites" class="single-location location-four video-btn">
                <i class="bx bx-location-plus"></i>
                <span>Brazil</span>
            </div>

            <div *ngIf="showSites" class="single-location location-five video-btn">
                <i class="bx bx-location-plus"></i>
                <span>Australia</span>
            </div>

            <div *ngIf="showSites" class="single-location location-six video-btn">
                <i class="bx bx-location-plus"></i>
                <span>Washington</span>
            </div>
        </div>

        <ul *ngIf="showSites" class="by-domain">
            <li><span>Russia</span> (50)</li>
            <li><span>London</span> (90)</li>
            <li><span>Canada</span> (80)</li>
            <li><span>Brazil</span> (40)</li>
            <li><span>Australia</span> (60)</li>
            <li><span>Washington</span> (70)</li>
        </ul>
    </div>
</section>